import onDomReady from './onDomReady';
import { loadPage, setupPagination, resetPagination } from './events/paginator';
import { setupFilters, getFilterParams } from './events/filters';
import naja from 'naja';

onDomReady(() => {
	setupFilters(onFilterChange);
	setupPagination();
	loadPage(0, getFilterParams());
});

function onFilterChange() {
	resetPagination();
	loadPage(0, getFilterParams(), false);
}
